import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { arrayOf, bool, color, element, eventListener, number, object, oneOf, oneOfType, record, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { enumValues } from '@philips-internal/oswald-ui-utils';
import { BaseCardListOrientation } from '../base-card-list/base-card-list-constants.js';
const CardProperties = {
    children: {
        type: oneOfType([element, arrayOf(element)]).notEnumerable(),
    },
    className: {
        type: string,
    },
    data: {
        type: object,
    },
    disabled: {
        type: bool,
    },
    onClick: {
        type: eventListener,
    },
    onContextMenuClick: {
        type: eventListener,
    },
    onDoubleClick: {
        type: eventListener,
    },
    onSelect: {
        type: eventListener,
    },
    orientation: {
        defaultValue: BaseCardListOrientation.VERTICAL,
        type: oneOf(enumValues(BaseCardListOrientation)).notEnumerable(),
    },
    padding: {
        defaultValue: '',
        type: string.group('spacing'),
    },
    role: {
        type: string.notEnumerable(),
    },
    selectable: {
        type: bool.notEnumerable(),
    },
    selected: {
        type: bool.notEnumerable(),
    },
    selectionType: {
        type: oneOf(enumValues(SelectionType)).notEnumerable(),
    },
    superscription: {
        type: record({ color: color, icon: oneOfType([string, element]), label: string, value: string }),
    },
    superscriptionEntry: {
        type: string,
    },
    transparent: {
        defaultValue: true,
        type: bool,
    },
    uuid: {
        defaultValue: '',
        type: string,
    },
    width: {
        defaultValue: 3,
        type: number,
    },
};
export { CardProperties, };
//# sourceMappingURL=card-types.js.map